export default {
  'cardAdministrators.domain.name': 'Name',
  'cardAdministrators.domain.cnpj': 'CNPJ',
  'cardAdministrators.domain.stateRegistration': 'State Registration',

  'cardAdministrators.create': 'Create Card Administrator',
  'cardAdministrators.create.notification.success': 'Success',
  'cardAdministrators.create.notification.successDescription':
    'Card Administrator created.',

  'cardAdministrators.update': 'Update Card Administrator',
  'cardAdministrators.update.notification.success': 'Success',
  'cardAdministrators.update.notification.successDescription':
    'Card Administrator updated.',

  'cardAdministrators.remove': 'Remove Card Administrator',
  'cardAdministrators.remove.alert':
    'Do you really want to remove the card administrator:',
  'cardAdministrators.remove.notification.success': 'Success',
  'cardAdministrators.remove.notification.successDescription':
    'Card Administrator removed.',

  'cardAdministrators.generateReport': 'Generate Report',
};
